/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
    // Add custom code below this line

    var buttons = document.querySelectorAll(".full-read-btn");
    buttons.forEach(function (button) {
        button.addEventListener("click", function () {
            var closestContent = findClosest(this, ".image-with-text__content");
            if (closestContent) {
                closestContent.classList.toggle("full");
            }
        });
    });

    function findClosest(element, selector) {
        while (element && !element.matches(selector)) {
            element = element.parentElement;
        }
        return element;
    }

    function checkIfElementExists(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    // Example usage
    let elementExists = checkIfElementExists("popup__close");

    if (elementExists) {
        var pressPopupLinks = document.querySelectorAll(".press__link");
        var pressPopup = document.getElementById("popup--press");
        var pressPopupClose = pressPopup.querySelector(".popup__close");

        pressPopupLinks.forEach(function (link) {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                let text = link.dataset.text,
                    name = link.dataset.name,
                    imageUrl = link.dataset.image,
                    popupFullTextElement = pressPopup.querySelector(".popup__full_text"),
                    popupNameElement = pressPopup.querySelector(".popup__name");
                popupImageElement = pressPopup.querySelector(".popup__image img");

                popupFullTextElement.innerHTML = text;
                popupNameElement.textContent = name;
                popupImageElement.src = imageUrl;

                pressPopup.classList.toggle("popup--visible");
            });
        });

        pressPopupClose.addEventListener("click", function (e) {
            pressPopup.classList.toggle("popup--visible");
        });
    }

    // var links = document.links;
    // for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    //     if (links[i].hostname !== window.location.hostname) {
    //         links[i].target = "_blank";
    //         links[i].rel = "noreferrer noopener";
    //     }
    // }

    document.addEventListener('sealsubs:subscription_widget_created', function (e) {
        document.querySelectorAll('.sealsubs-target-element').forEach(el => el.style.display = 'none');
    });


    // Ensure the DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        // Select all elements with the class .yt-video .yt-video-link
        const ytVideoLinks = document.querySelectorAll('.yt-video .yt-video-link');

        // Check if there are any .yt-video .yt-video-link elements
        if (ytVideoLinks.length > 0) {
            // Add a click event listener to each .yt-video .yt-video-link
            ytVideoLinks.forEach(function (ytVideoLink) {
                ytVideoLink.addEventListener('click', function (event) {
                    // Prevent the default action if necessary
                    event.preventDefault();

                    // Find the parent .slide__text__container
                    const slideTextContainer = ytVideoLink.closest('.slide__text__container');

                    // If the parent .slide__text__container is found
                    if (slideTextContainer) {
                        // Find the .video-text-link within the same parent
                        const videoTextLink = slideTextContainer.querySelector('.video-text-link');

                        // If .video-text-link is found, trigger a click event on it
                        if (videoTextLink) {
                            videoTextLink.click();
                        }
                    }
                });
            });
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        var isWindows = navigator.userAgent.indexOf('Windows') !== -1;
        if (isWindows) {
            document.body.classList.add('windows');
        }
    });

    // CWV FIX: INP optimization — lazy-load non-critical images site-wide
    // This complements the article-level CWV fixes in sections/article.liquid
    document.addEventListener('DOMContentLoaded', function () {
        // Add lazy loading to all non-article images that are not already marked
        var allImgs = document.querySelectorAll('img:not([loading]):not([fetchpriority])');
        var aboveFoldCount = 0;
        allImgs.forEach(function (img) {
            // Skip first 3 images (likely above fold)
            if (aboveFoldCount < 3) {
                aboveFoldCount++;
                return;
            }
            img.setAttribute('loading', 'lazy');
            img.setAttribute('decoding', 'async');
        });

        // INP: Use passive event listeners for scroll-triggered interactions
        // This reduces main thread blocking during scroll
        if (typeof IntersectionObserver !== 'undefined') {
            var lazyBgs = document.querySelectorAll('[data-bg-lazy]');
            if (lazyBgs.length > 0) {
                var bgObserver = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            var el = entry.target;
                            var bg = el.getAttribute('data-bg-lazy');
                            if (bg) { el.style.backgroundImage = 'url(' + bg + ')'; }
                            bgObserver.unobserve(el);
                        }
                    });
                }, { rootMargin: '200px' });
                lazyBgs.forEach(function (el) { bgObserver.observe(el); });
            }
        }
    });

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
